import { gql } from '@apollo/client'

export const Query = gql`
  query EditMaintenanceTypes($companyId: ID!, $filters: MaintenanceTypeFilters) {
    maintenanceTypes(companyId: $companyId, filters: $filters, first: 1) {
       nodes {
        id
        maintenanceTypeTasks { 
          id
        }
        color
        name
      }
    }
  }
`
